import React from "react"

export default function NotFoundPage() {
	return (
		<React.Fragment>
			<div className="flex flex-align-center flex-justify-center full-height">
				<h1>Not found</h1>
			</div>
		</React.Fragment>
	)
}